import React, { useState } from "react";
import { Button } from "antd";
import colors from "../../../assets/styles/colour";
import { px } from "framer-motion";

const PrimaryButton = ({ children, onClick, style = {}, ...props }) => {
    // State to manage hover effect
    const [isHovered, setIsHovered] = useState(false);
  
    // Button style with hover effect
    const primaryButtonStyle = {
      background: "#ffffff",
      color: colors.button,
      border: `2px solid ${colors.button}`,
      borderRadius: "10px",
      transition: "all 0.3s ease",
      ...(isHovered && {
        background: colors.button,
        color: "#ffffff",
      }),
    };


    return (
        <Button
          style={{ ...primaryButtonStyle, ...style }}
          onClick={onClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          {...props}
        >
          {children}
        </Button>
      );
    };


export default PrimaryButton;
